import { render, staticRenderFns } from "./NotificationListSection.vue?vue&type=template&id=017928c7&scoped=true"
import script from "./NotificationListSection.vue?vue&type=script&lang=ts"
export * from "./NotificationListSection.vue?vue&type=script&lang=ts"
import style0 from "./NotificationListSection.vue?vue&type=style&index=0&id=017928c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "017928c7",
  null
  
)

export default component.exports